import { useTypedParams } from '@sorare/routing';

import { LeaderboardPage as GameplayLeaderboardPage } from '@sorare/gameplay/src/components/collections/LeaderboardPage';

import type { PageParams } from './__generated__/routeParams';

const LeaderboardPage = () => {
  const { collection, slug } = useTypedParams<PageParams>();
  return <GameplayLeaderboardPage collection={collection} slug={slug} />;
};

export default LeaderboardPage;
